<!-- Dropdown with Checkboxes for selecting multiple entries -->
<script>
    export let device_customers;
    export let owner_id;
    let is_open = false;
    let dropdown,dropdown_button;
    let style = "";

    import { tick } from "svelte";

    import { customer_list } from "../../stores.js";

    function handle_multiple_selection(id) {
        if (device_customers.includes(id)) {
            let temp = device_customers.filter((item) => item !== id);
            device_customers = temp;
        } else {
            device_customers = [...device_customers, id];
        }
    }

    async function handle_menu() {
        if (is_open) {
            is_open = false;
            style = "";
            document.removeEventListener("mousedown", handle_click_outside);
        } else {
            style = "";
            is_open = true;
            await tick();
            if (
                dropdown.getBoundingClientRect().y +
                    dropdown.getBoundingClientRect().height >
                window.innerHeight
            ) {
                let height = dropdown.getBoundingClientRect().height + 40;
                style = "transform: translate3d(0px, -" + height + "px, 0px)";
            }
            document.addEventListener("mousedown", handle_click_outside);
        }
    }

    function handle_click_outside(event) {
        if (dropdown && !dropdown.contains(event.target) && !dropdown_button.contains(event.target)) {
            is_open = false;
            style = "";
            document.removeEventListener("mousedown", handle_click_outside);
        }
    }
</script>

<div class="input-group mb-2 mt-1">
    <button
    bind:this={dropdown_button}
        class="primary-color btn btn-transparent btn-normal btn-block dropdown-toggle"
        id="geraete_id"
        type="button"
        aria-haspopup="true"
    style="font-weight: bold;"

        aria-expanded="false"
        on:click|stopPropagation={handle_menu}
    >
        {device_customers.length > 0
            ? device_customers.length == 1
                ? "sichtbar für 1 weiteren Kunden"
                : "sichtbar für " + device_customers.length + " weitere Kunden"
            : "nur Besitzer"}
    </button>
    {#if is_open}
        <div
            bind:this={dropdown}
            class="dropdown-menu svelte-dropdown filter_dropdown mt-2 show"
            aria-labelledby="geraete_id"
            {style}
        >
            <div class="filter_dropdown_scrollable" id="alle_geraete_ids">
                {#each $customer_list as customer}
                {#if customer.id != owner_id && customer.id != $customer_list[0].id}
                    <label
                        on:keydown={() => {}}
                        on:click|stopPropagation
                        class="dropdown__checkbox dropdown__label"
                    >
                        <input
                            on:click|stopPropagation={() =>
                                handle_multiple_selection(customer.id)}
                            type="checkbox"
                            class="checkbox_test"
                            checked={device_customers.includes(customer.id)}
                        />
                        {customer.name}</label
                    >
                    {/if}
                {/each}
            </div>
        </div>
    {/if}
</div>
